import { createContext } from 'react';
import { defaultGetItemSize, defaultRowRenderer } from './utils';

export const VIRTUALIZED_SCROLL_CONTEXT_DEFAULT_VALUE = {
  getItemSize: defaultGetItemSize,
  rowRenderer: defaultRowRenderer,
};

export const VirtualizedScrollContext = createContext(VIRTUALIZED_SCROLL_CONTEXT_DEFAULT_VALUE);
